import React, { useState, useEffect } from "react";
import { fetchUsers } from "../api/userService"; // Ensure this API is implemented

function UserSearchDropdown({ value, onChange }) {
  const [query, setQuery] = useState(value || "");
  const [users, setUsers] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (query.length < 2) {
      setUsers([]);
      return;
    }

    

    const fetchMatchingUsers = async () => {
      setLoading(true);
      try {
        const response = await fetchUsers({ search: query });
        setUsers(response);
      } catch (err) {
        setError("Failed to fetch users.");
      } finally {
        setLoading(false);
      }
    };

    const debounceTimeout = setTimeout(fetchMatchingUsers, 300); // Debounce API calls
    return () => clearTimeout(debounceTimeout);
  }, [query]);

  useEffect(() => {
    if (value) {
      setQuery(value); // ✅ Pre-fill the user name when editing a lead
    }
  }, [value]);

  const handleSelectUser = (user) => {
    setQuery(user.username);
    setSelectedUser(user);
    setShowDropdown(false);
    onChange(user.user_id); // Send the selected user_id to the parent component
  };

  return (
    <div className="relative w-full">
      <input
        type="text"
        value={query}
        onChange={(e) => {
          setQuery(e.target.value);
          setShowDropdown(true);
        }}
        placeholder="Search user by name"
        className="border p-2 rounded w-full"
      />
      {loading && <p className="text-sm text-gray-500">Loading...</p>}
      {error && <p className="text-sm text-red-500">{error}</p>}

      {showDropdown && users.length > 0 && (
        <ul className="absolute z-10 bg-white border rounded-md shadow-lg mt-1 w-full max-h-40 overflow-y-auto">
          {users.map((user) => (
            <li
              key={user.user_id}
              onClick={() => handleSelectUser(user)}
              className="px-4 py-2 cursor-pointer hover:bg-gray-100"
            >
              {user.username} ({user.first_name} {user.last_name})
            </li>
          ))}
        </ul>
      )}

      {selectedUser && (
        <p className="text-sm text-gray-600 mt-1">Selected: {selectedUser.username}</p>
      )}
    </div>
  );
}

export default UserSearchDropdown;